import { render, staticRenderFns } from "./MerchNotify.vue?vue&type=template&id=8b13f1ee&scoped=true"
import script from "./MerchNotify.vue?vue&type=script&lang=ts"
export * from "./MerchNotify.vue?vue&type=script&lang=ts"
import style0 from "./MerchNotify.vue?vue&type=style&index=0&id=8b13f1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b13f1ee",
  null
  
)

export default component.exports